import { trendsService } from '../../../services/trends/trends-service'

/**
 * Fetch trends method for the useTrends composable
 * @param {Object} state - Trends state object
 * @param {Function} t - Translation function
 * @returns {Function} Fetch trends function
 */
export const createFetchTrends = (state) => {
  /**
   * Fetch trends based on the selected type
   * @param {string} assetId - Asset ID
   * @param {string} errorMessage - Custom error message
   * @returns {Promise<Array>} Trends array
   */
  return async (assetId, errorMessage) => {
    // Update loading state
    state.isLoadingTrends.value = true
    
    try {
      // Use trends service to fetch trends
      const trends = await trendsService.fetchTrends(
        assetId, 
        state.selectedTrendType.value,
        errorMessage
      )
      
      // Update state with fetched trends
      state.trendsList.value = trends || []
      return trends
    } catch (error) {
      console.error('Error in fetchTrends composable method:', error)
      state.trendsList.value = []
      return []
    } finally {
      // Reset loading state
      state.isLoadingTrends.value = false
    }
  }
}
